import {
  setOpenAuthModal,
  closeModalGoHome,
  login,
  setLoginUsername,
} from "../../../modules/login";

const initialState = {};

export const userLoginReducer = (state = initialState, action) => {
  return state;
};

export const mapStateToProps = (state) => {
  return {
    loginUsername: state.loginReducer.loginUsername,
  };
};

export const mapDispatchToProps = {
  setOpenAuthModal,
  closeModalGoHome,
  login,
  setLoginUsername,
};
